module.exports = __webpack_public_path__ + "img/postcard.80b4ba01.png";